import { createAction } from "redux-actions";

export const CREATE_AFFILIATE = "CREATE_AFFILIATE";
export const createAffiliate = createAction(CREATE_AFFILIATE);

export const CURRENT_AFFILIATE = "CURRENT_AFFILIATE";
export const currentAffiliate = createAction(CURRENT_AFFILIATE);

export const DETAIL_AFFILIATE = "DETAIL_AFFILIATE";
export const detailAffiliate = createAction(DETAIL_AFFILIATE);

export const AFFILIATE_LIST = "AFFILIATE_LIST";
export const affiliateList = createAction(AFFILIATE_LIST);

export const UPDATE_AFFILIATE = "UPDATE_AFFILIATE";
export const updateAffiliate = createAction(UPDATE_AFFILIATE);

export const UPDATE_STATUS_AFFILIATE = "UPDATE_STATUS_AFFILIATE";
export const updateStatusAffiliate = createAction(UPDATE_STATUS_AFFILIATE);

export const DELETE_AFFILIATE = "DELETE_AFFILIATE";
export const deleteAffiliate = createAction(DELETE_AFFILIATE);

export const AFFILIATE_PRODUCTS = "AFFILIATE_PRODUCTS";
export const affiliateProducts = createAction(AFFILIATE_PRODUCTS);

export const AFFILIATELINK_ADD = "AFFILIATELINK_ADD";
export const affiliateLinkAdd = createAction(AFFILIATELINK_ADD);

// withdraw
export const AFFILIATE_WITHDRAW = "AFFILIATE_WITHDRAW";
export const affiliateWithdraw = createAction(AFFILIATE_WITHDRAW);

export const AFFILIATE_WITHDRAW_UPDATE = "AFFILIATE_WITHDRAW_UPDATE";
export const affiliateWithdrawUpdate = createAction(AFFILIATE_WITHDRAW_UPDATE);

export const AFFILIATE_WITHDRAW_ADD = "AFFILIATE_WITHDRAW_ADD";
export const affiliateWithdrawAdd = createAction(AFFILIATE_WITHDRAW_ADD);

export const AFFILIATE_WITHDRAW_DETAIL = "AFFILIATE_WITHDRAW_DETAIL";
export const affiliateWithdrawDetail = createAction(AFFILIATE_WITHDRAW_DETAIL);

// bank
export const AFFILIATE_BANK_LIST = "AFFILIATE_BANK_LIST";
export const affiliateBankList = createAction(AFFILIATE_BANK_LIST);

export const AFFILIATE_BANK_ADD = "AFFILIATE_BANK_ADD";
export const affiliateAddBank = createAction(AFFILIATE_BANK_ADD);

export const AFFILIATE_BANK_UPDATE = "AFFILIATE_BANK_UPDATE";
export const affiliateUpdateBank = createAction(AFFILIATE_BANK_UPDATE);

export const AFFILIATE_BANK_DETAILE = "AFFILIATE_BANK_DETAILE";
export const affiliateDetailBank = createAction(AFFILIATE_BANK_DETAILE);

export const AFFILIATE_BANK_DELETE = "AFFILIATE_BANK_DELETE";
export const affiliateDeleteBank = createAction(AFFILIATE_BANK_DELETE);

// commission
export const AFFILIATE_COMMISSION = "AFFILIATE_COMMISSION";
export const affiliateCommission = createAction(AFFILIATE_COMMISSION);

export const AFFILIATE_COMMISSION_DETAIL = "AFFILIATE_COMMISSION_DETAIL";
export const affiliateCommissionDetail = createAction(
  AFFILIATE_COMMISSION_DETAIL
);
